import { FormFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import InputGroup from './InputGroup.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.String,
    widget: 'InputGroup',
    multi: false
  })
)
export class FormStringInputGroupFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(InputGroup);
    return this;
  }
}